(function ($, Drupal, once) {

  'use strict';

  /**
   * Move language switcher link into footer menu.
   * @type {{attach: Drupal.behaviors.promutuel_language_switch_footer.attach}}
   */
  Drupal.behaviors.promutuel_language_switch_footer = {
    attach: function attach(context) {

      once('promutuelLanguageSwitchFooter', '.footer__bottom', context).forEach( () => {
        const languageSwitch = document.querySelector('#block-promutuel-language-switcher-footer');
        if (languageSwitch !== null && languageSwitch.length > 0) {
          const link = languageSwitch.querySelector('.links li:not(.is-active)');
          const footerMenu = document.querySelector('#block-promutuel-footer .menu');
          footerMenu.appendChild(link);
        }
      });
    }
  };

})(jQuery, Drupal, once);
